import { Colors } from "../utils/colors";

export default function Loader() {
  return (
    <div style={styles.container}>
      <div style={styles.spinner} />
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    width: 40,
    height: 40,
    border: "4px solid rgba(255,255,255,0.3)",
    borderTop: `4px solid ${Colors.SecondaryColor}`,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};
